(function () {
  const toggle = document.querySelector("[data-menu-toggle]");
  const nav = document.querySelector("[data-mobile-nav]");
  if (toggle && nav) {
    toggle.addEventListener("click", function () {
      const open = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  document.querySelectorAll("[data-qty]").forEach(function (wrap) {
    const input = wrap.querySelector("input");
    wrap.querySelectorAll("button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        const delta = Number(btn.dataset.delta || 0);
        const next = Math.max(1, Number(input.value || 1) + delta);
        input.value = String(next);
      });
    });
  });
  const gallery = document.querySelector("[data-gallery]");
  if (gallery) {
    const main = gallery.querySelector("[data-gallery-main]");
    gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (main && btn.dataset.src) {
          main.src = btn.dataset.src;
          main.alt = btn.dataset.alt || main.alt;
        }
        gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (b) {
          b.classList.toggle("is-active", b === btn);
        });
      });
    });
  }

  const related = document.querySelector("[data-related][data-url]");
  if (related) {
    fetch(related.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const next = doc.querySelector("[data-related]");
        if (next) related.innerHTML = next.innerHTML;
      })
      .catch(function () {});
  }
  const sky = document.createElement("div");
  sky.className = "sky-stars";
  sky.setAttribute("aria-hidden", "true");
  document.body.appendChild(sky);
  const count = window.innerWidth < 700 ? 280 : 520;
  for (let i = 0; i < count; i++) {
    const s = document.createElement("span");
    const size = Math.random() < 0.55 ? 1 : Math.random() < 0.8 ? 2 : 3;
    s.style.width = size + "px";
    s.style.height = size + "px";
    s.style.left = Math.random() * 100 + "%";
    s.style.top = Math.random() * 100 + "%";
    s.style.animationDuration = 1.8 + Math.random() * 4.5 + "s";
    s.style.animationDelay = Math.random() * 6 + "s";
    s.style.setProperty("--max", (0.35 + Math.random() * 0.65).toFixed(2));
    sky.appendChild(s);
  }
})();